import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "form",
  class: "grid grid-cols-6 gap-6 mt-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_3 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_4 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Sex Assigned at Birth "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_6 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_7 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_8 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_9 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_10 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_11 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }

import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { renderSelectV2, renderSelect } from "@/interfaces/DropdownInterface";
import { type PropType, computed } from "vue";
import { ref } from "vue";
import { EditPatient } from "@/interfaces/PatientInterface";
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	form: {
		type: Object as PropType<EditPatient>,
		required: true,
	},
	civilStatuses: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	nationalities: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	religions: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	sexAtBirth: {
		type: [] as PropType<renderSelectV2>,
		default: [],
	},
	indigeneous: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	errors: {
		type: Object,
		required: true,
	},
	disabled: {
		type: Boolean,
		required: false,
	},
},
  setup(__props) {

const props = __props;

const form = ref<object>(props.form);
const maxDate = () => {
	return new Date().toISOString().split("T")[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DatePicker, {
        id: "patient_registered",
        name: "patient_registered",
        label: "Date Registered",
        required: "",
        "model-value": form.value?.registered_at,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => (form.value.registered_at = value)),
        error: __props.errors?.registered_at,
        maxDate: maxDate,
        disabled: __props.disabled
      }, null, 8, ["model-value", "error", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(RadioGroup, {
          options: __props.sexAtBirth,
          name: "gender",
          required: "",
          modelValue: form.value.sex_at_birth,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sex_at_birth) = $event)),
          disabled: __props.disabled
        }, null, 8, ["options", "modelValue", "disabled"]),
        (__props.errors?.sex_at_birth)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["text-[10px] mt-1", __props.errors?.sex_at_birth ? 'text-red-600' : 'text-gray-800']),
              id: "email-error"
            }, _toDisplayString(__props.errors?.sex_at_birth), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(MultiSelect, {
        options: __props.indigeneous,
        id: "ethnicity",
        name: "ethnicity",
        label: "Indigenous Group",
        placeholder: "Select..",
        searchable: "",
        modelValue: form.value.indigeneous_people_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.indigeneous_people_id) = $event)),
        error: __props.errors?.indigeneous_people_id,
        disabled: __props.disabled
      }, null, 8, ["options", "modelValue", "error", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(TextInput, {
        type: "text",
        label: "Last Name",
        placeholder: "Last name",
        name: "last_name",
        id: "last_name",
        required: "",
        modelValue: form.value.last_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.last_name) = $event)),
        error: __props.errors?.last_name,
        disabled: __props.disabled
      }, null, 8, ["modelValue", "error", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(TextInput, {
        type: "text",
        label: "First Name",
        placeholder: "First name",
        name: "first_name",
        id: "first_name",
        required: "",
        modelValue: form.value.first_name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.first_name) = $event)),
        error: __props.errors?.first_name,
        disabled: __props.disabled
      }, null, 8, ["modelValue", "error", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(TextInput, {
        type: "text",
        label: "Middle Name",
        placeholder: "Middle name",
        name: "middle_name",
        id: "middle_name",
        modelValue: form.value.middle_name,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.middle_name) = $event)),
        error: __props.errors?.middle_name,
        disabled: __props.disabled
      }, null, 8, ["modelValue", "error", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.civilStatuses,
        id: "civil_status",
        name: "civil_status",
        label: "Civil Status",
        placeholder: "Select..",
        required: "",
        modelValue: form.value.civil_status_id,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.civil_status_id) = $event)),
        error: __props.errors?.civil_status_id,
        disabled: __props.disabled
      }, null, 8, ["options", "modelValue", "error", "disabled"])
    ])
  ]))
}
}

})